import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function Customers() {
  const navigate = useNavigate();
  const { can } = useAuth();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ first_name: "", last_name: "", phone: "", email: "", tax_code: "" });

  const load = () => api.get("/customers", { params: { q: q || undefined } }).then((r) => setRows(r.data));
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q]);

  const create = async () => {
    try {
      await api.post("/customers", f);
      toast.success("Cliente creato"); setOpen(false);
      setF({ first_name: "", last_name: "", phone: "", email: "", tax_code: "" }); load();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-heading text-2xl font-extrabold tracking-tight sm:text-3xl">Clienti</h1>
        {can("customers.manage") && <Button data-testid="new-customer-btn" onClick={() => setOpen(true)}>Nuovo cliente</Button>}
      </div>
      <Input placeholder="Cerca per nome, telefono, email…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-md" data-testid="customer-search" />

      <Card className="overflow-hidden">
        <div className="divide-y divide-border">
          {rows.map((c) => (
            <button key={c.id} data-testid={`customer-row-${c.id}`} onClick={() => navigate(`/customers/${c.id}`)}
              className="flex w-full items-center gap-4 px-5 py-3 text-left transition-colors hover:bg-secondary">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 font-semibold text-primary">
                {c.first_name[0]}{c.last_name[0]}
              </span>
              <span className="flex-1 font-medium">{c.first_name} {c.last_name}</span>
              <span className="text-sm text-muted-foreground">{c.phone}</span>
              <span className="rounded-full bg-secondary px-2.5 py-0.5 text-xs">{c.repair_count} riparazioni</span>
            </button>
          ))}
          {rows.length === 0 && <div className="px-5 py-12 text-center text-muted-foreground">Nessun cliente.</div>}
        </div>
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Nuovo cliente</DialogTitle></DialogHeader>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2"><Label>Nome *</Label><Input data-testid="cust-firstname" value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} /></div>
            <div className="space-y-2"><Label>Cognome *</Label><Input data-testid="cust-lastname" value={f.last_name} onChange={(e) => setF({ ...f, last_name: e.target.value })} /></div>
            <div className="space-y-2"><Label>Telefono *</Label><Input data-testid="cust-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} /></div>
            <div className="space-y-2"><Label>Email</Label><Input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></div>
          </div>
          <DialogFooter><Button data-testid="save-customer-btn" onClick={create}>Salva</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
